// extracted by mini-css-extract-plugin
export default {"button":"VUdhto0yztUFRKR79etc9","errorMessage":"_71ddPubZ8lsJ18FBeTxT3A"};